import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { changeWifiConnectivityAction } from './connectivity.actions';
import { IConnectivityFeature } from './connectivity.feature.state';
import { getConnectivityWifiStatus, getIsLoading } from './connectivity.selector';
import { Injectable } from '@angular/core';
import { ConnectivityStatusEnum } from '../enums';

@Injectable()
export class ConnectivityFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public isWifiConnected$ = this.store
    .select(getConnectivityWifiStatus)
    .pipe(filter((isConnected) => isConnected !== ConnectivityStatusEnum.Uninitialized));

  constructor(private store: Store<IConnectivityFeature>) {}

  public changeWifiConnectivity(newStatus: boolean): void {
    this.store.dispatch(changeWifiConnectivityAction({ status: newStatus }));
  }
}
